import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import posthog from 'posthog-js'
import { environment } from './environments/environment';

if(environment.production) {
    posthog.init(
        environment.posthogKey,
        {
            api_host: environment.posthogHost,
            person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
        }
    )
}
bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
